import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { PaymentService } from '../payment.service';
import THBText from 'thai-baht-text'
import { Logo } from 'src/app/shared/logo-encode';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import pdfMake from 'pdfmake/build/pdfmake';
import { PaymentManagementService } from '../../payment-management/payment-management.service';
import { Location } from '@angular/common';
import { LogoChulaBlackWhite } from 'src/app/shared/logo-chula-black-white';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss']
})
export class TransferComponent implements OnInit {

  paymentID;
  price;
  evidenceForm;
  slip: string;
  slipFile: File;
  slipPic = '';
  isLoading: boolean;
  today: Date;
  fileList: NzUploadFile[] = [];
  slipDelete: number[] = [];
  numRegex = /^-?\d*[.,]?\d{0,2}$/;

  successRequest = ({ file, onSuccess, onError }) => {
    const fileType = this.gobalFunctionService.getTypeFile(file);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv' || fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    } else {
      setTimeout(() => {
        onError('error');
      }, 0);
    }
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private gbFunction: GobalFunctionService,
    public matDialog: MatDialog,
    private paymentManagementService: PaymentManagementService,
    private _location: Location,
    private gobalFunctionService: GobalFunctionService,
  ) {
    this.today = new Date();
  }

  ngOnInit(): void {
    this.isLoading = false;
    this.paymentID = new URL(location.href).searchParams.get('paymentID');
    this.price = new URL(location.href).searchParams.get('price');
    this.gobalFunctionService.setTitle('แนบเอกสารการโอน');
    // // console.log(this.paymentID);
    // // console.log(this.price);
    // // console.log(this.paymentService.billerForm);
    // // console.log(this.paymentService.receiptBody);

    this.evidenceForm = this.fb.group({
      PAYMENT_ID: [this.paymentID, Validators.required],
      TRANFER_DATE: ['', Validators.required],
      TRANFER_HR: ['', Validators.required],
      TRANFER_MIN: ['', Validators.required],
      TRANFER_PRICE: ['', Validators.required],
      slip: ['', Validators.required],
      evidence: ['']
    })

    if (!this.paymentService.billerForm) {
      this._location.back();
    } else {

    }

  }

  paid(e) {
    let date = this.evidenceForm.value.TRANFER_DATE;
    // // console.log(date.toString());
    // // console.log(e);
    // // console.log(date);

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;
    dialogConfig.width = '500px';

    dialogConfig.data = {
      title: 'แจ้งโอน',
      description: `<p>กรุณากรอกรายละเอียดหลักฐานให้ตรงกับสลิป</p>
      <p>ตรวจสอบหลักฐานการแจ้งโอน <span class="text-success">ถูกต้องครบถ้วน</span> แล้วหรือไม่</p>`,
      actionBtnText: 'ตกลง',
      cancleBtnText: 'ย้อนกลับ',
      isConfirm: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.isLoading = true;
    formDialog.afterClosed().pipe(

      switchMap(isConfirm => {
        if (isConfirm) {
          return this.paymentService.payByTransfer(e).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '400px';
                dialogConfig.data = {
                  title: 'แจ้งโอนสำเร็จ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                <p class="title text-center">แจ้งโอนสำเร็จ</p>
                                <p class="text-center">ระบบกำลังตรวจสอบหลักฐานการโอนของคุณ</p>
                                <p class="text-center">สามารถตรวจสอบได้ในประวัติการชำระเงิน</p>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B'
                }
              }

              // // console.log(this.paymentService.receiptBody);
              // this.openPdf(this.paymentService.receiptBody);

              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed().pipe(
                map(r => {
                  if (!r) {
                    this.router.navigate(['/']);

                  }
                })
              )
            })
          )
        } else {
          this.isLoading = false;
          // // console.log(isConfirm);
          return of(null)
        }
      }),
      catchError((err) => {
        // // console.log(err);
        alert(err);
        this.router.navigate(['/']);
        return of(null);
      }),
    ).subscribe();
  }

  onSlipSelected(e, evidenceForm) {
    // console.log(e);
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    const reader = new FileReader();

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.slip = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        this.slipFile = file;

        reader.readAsDataURL(file);
        reader.onload = () => {
          this.slipPic = reader.result as string;
        };


        evidenceForm.patchValue({
          slip: file
        });
        evidenceForm.get('slip').updateValueAndValidity()
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  time(e, t) {
    // // console.log(e.target.value);
    switch (t) {
      case 'hr': {
        if (e.target.value > 23) {
          // this.evidenceForm.value.TRANFER_HR = 23;
          this.evidenceForm.controls['TRANFER_HR'].setValue(23);
        }
        break;
      }
      case 'min': {
        if (e.target.value > 59) {
          // this.evidenceForm.value.TRANFER_HR = 23;
          this.evidenceForm.controls['TRANFER_MIN'].setValue(59);
        }
        break;
      }
    }
  }

  handleChange(e, evidenceForm) {
    let fileList = [...e.fileList];
    const fileType = this.gobalFunctionService.getTypeFile(e.file);

    switch (e.file.status) {
      case 'done': {
        if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv' || fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
          if (fileList.length > 5) {
            let removeExcess = [...fileList].splice(0, fileList.length - 5);

            e.fileList = fileList.slice(-5);

            for (let i = 0; i < removeExcess.length; i++) {
              if (removeExcess[i].uid) {
                this.slipDelete.push(removeExcess[i].uid)
              }
            }
          }

          // upload 5 files เกิน 5 จะลบอันแรก
          fileList = fileList.slice(-5);
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.url;
            }
            return file;
          });

          evidenceForm.patchValue({
            evidence: e
          });
          evidenceForm.get('evidence').updateValueAndValidity()

          this.fileList = fileList;
        }
        break;
      }

      case 'removed': {
        if (typeof (e.file.uid) === 'number') {
          this.slipDelete.push(e.file.uid)
        } else {
          evidenceForm.patchValue({
            evidence: e
          });
          evidenceForm.get('evidence').updateValueAndValidity()
        }
        break;
      }
    }
    // console.log(evidenceForm);
  }

  // openPdf(receipt) {

  //   pdfMake.fonts = {
  //     THsarabunNew: {
  //       normal: 'THSarabun.ttf',
  //       bold: 'THSarabunNew Bold.ttf',
  //       italics: 'THSarabunNew Italic.ttf',
  //       bolditalics: 'THSarabunNew BoldItalic.ttf',
  //     },
  //   };

  //   var documentDefinition = {
  //     content: [
  //       // Header
  //       {
  //         columns: [
  //           [
  //             {
  //               image: LogoChulaBlackWhite,
  //               width: 50,
  //               style: 'logoChulaTitle'
  //             },
  //           ],
  //         ],
  //       },
  //       {
  //         columns: [
  //           {
  //             image: Logo,
  //             width: 110,
  //             style: 'logoTitle'
  //           },
  //           [
  //             {
  //               text: 'ใบเสร็จรับเงิน (Receipt)',
  //               style: 'receiptTitle',
  //               width: '*'
  //             },
  //           ],
  //         ],
  //       },
  //       {
  //         columns: [
  //           [
  //             {
  //               text: `วันที่: ${new DatePipe().transform(this.evidenceForm.value.TRANFER_DATE.toString(), 'full')}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `เลขที่: ${receipt.paymentID}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `ช่องทางการชำระเงิน: ${receipt.type}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `ชื่อผู้รับใบเสร็จ: ${receipt.userName ? receipt.userName : '-'}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `โทร: ${receipt.userPhone ? receipt.userPhone : '-'}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `เลขที่ผู้เสียภาษี: ${receipt.taxID ? receipt.taxID : '-'}`,
  //               style: 'subHeaderDetail',
  //             },
  //             {
  //               text: `ที่อยู่ผู้รับใบเสร็จ: ${receipt.userAddress ? receipt.userAddress : '-'}`,
  //               style: 'subHeaderDetail',
  //               width: 100
  //             },
  //           ],

  //           [
  //             {
  //               text: receipt.address,
  //               style: 'addressHeader',
  //               width: '*'
  //             },
  //             {
  //               text: receipt.subAddress,
  //               style: 'subAddressHeader',
  //               width: '*'
  //             },
  //             {
  //               text: 'https://www.chulalifedi.com/',
  //               style: 'urlHeader',
  //               width: '*'
  //             },
  //           ],

  //         ]
  //       },

  //       {
  //         table: {
  //           headerRows: 1,
  //           widths: ['*', 90],
  //           style: 'table',

  //           body: [
  //             [
  //               {
  //                 text: 'รายการ',
  //                 style: 'itemsHeader'
  //               },
  //               {
  //                 text: 'จำนวนเงิน (บาท)',
  //                 style: 'itemsHeader'
  //               }
  //             ],
  //             [
  //               {
  //                 text: receipt.paymentName,
  //                 style: 'itemsName'
  //               },
  //               {
  //                 text: receipt.standardPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  //                 style: 'itemsPrice'
  //               }
  //             ],
  //           ]
  //         },
  //       },
  //       {
  //         columns: [
  //           {
  //             text: '',
  //             width: '*',
  //             style: 'lineBreak'
  //           }
  //         ]
  //       },
  //       {
  //         columns: [
  //           {
  //             text: 'จำนวนเงิน',
  //             style: 'amountTH',
  //             width: 60
  //           },
  //           {
  //             text: receipt.thbath,
  //             style: 'amountTH',
  //             width: 195
  //           },
  //           [
  //             {
  //               text: 'รวมเป็นเงิน',
  //               style: 'amountFooter',
  //               width: '*'
  //             },
  //             {
  //               text: 'ส่วนลด',
  //               style: 'amountFooter',
  //               width: '*'
  //             },
  //             {
  //               text: 'จำนวนเงินรวมทั้งสิ้น',
  //               style: 'totalFooter',
  //               width: '*'
  //             },
  //           ],
  //           [
  //             {
  //               table: {
  //                 headerRows: 1,
  //                 widths: [90],

  //                 body: [
  //                   [
  //                     {
  //                       text: receipt.standardPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  //                       style: 'detailAmountFooter',
  //                       // fillColor: '#A4F0FF'
  //                       // fillColor: '#8BFEFF',
  //                       // hLineColor: '#8BFEFF',
  //                       // vLineColor: '#8BFEFF',
  //                     },
  //                   ],
  //                   [
  //                     {
  //                       text: receipt.discount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  //                       // text: price.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  //                       style: 'detailAmountFooter',
  //                       // fillColor: '#A4F0FF'
  //                     },
  //                   ],
  //                   [
  //                     {
  //                       text: receipt.price.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  //                       style: 'totalAmountFooter',
  //                       // fillColor: '#A4F0FF'
  //                     },
  //                   ],
  //                 ]
  //               },
  //               layout: 'lightHorizontalLines'
  //             },
  //           ],
  //         ]
  //       },
  //       {
  //         columns: [
  //           {
  //             text: '',
  //             width: '*',
  //             style: 'blankFooter'
  //           },
  //           [
  //             {
  //               image: receipt.signaturePic,
  //               width: 100,
  //               style: 'signatureImg'
  //             },
  //             {
  //               text: receipt.signatureName,
  //               width: '*',
  //               style: 'NameSignatureFooter'
  //             },
  //             {
  //               text: receipt.signatureJobTitle,
  //               width: '*',
  //               style: 'NameSignatureFooter'
  //             },
  //             {
  //               text: 'ผู้มีอำนาจลงนาม',
  //               width: '*',
  //               style: 'NameSignatureFooter'
  //             },
  //           ]
  //         ]
  //       },
  //     ],
  //     styles: {
  //       copyHeader: {
  //         fontSize: 17,
  //         alignment: 'right',
  //       },
  //       subHeader: {
  //         alignment: 'right'
  //       },
  //       subHeaderDetail: {
  //         alignment: 'left'
  //       },
  //       receiptTitle: {
  //         fontSize: 22,
  //         bold: true,
  //         alignment: 'right',
  //         margin: [0, 0, 0, 5]
  //       },
  //       logoTitle: {
  //         alignment: 'left',
  //         margin: [-5, -7, 0, 5]
  //       },
  //       userAddressHeader: {
  //         fontSize: 12,
  //         alignment: 'right',
  //         margin: [0, 7, 0, 0]
  //       },
  //       addressHeader: {
  //         fontSize: 13,
  //         bold: true,
  //         alignment: 'right'
  //       },
  //       subAddressHeader: {
  //         fontSize: 12,
  //         alignment: 'right',
  //         margin: [0, 0, 0, 5]
  //       },
  //       receiptSubTitle: {
  //         fontSize: 12,
  //         alignment: 'right',
  //         margin: [0, 0, 0, 0]
  //       },
  //       urlHeader: {
  //         fontSize: 12,
  //         alignment: 'right',
  //         color: '#3E82FB',
  //         margin: [0, 0, 0, 25]
  //       },
  //       itemsHeader: {
  //         margin: [10, 5, 0, 5],
  //         bold: true,
  //         fontSize: 15
  //       },
  //       itemsName: {
  //         margin: [10, 5, 0, 5],
  //         fontSize: 15,
  //         alignment: 'left'
  //       },
  //       itemsPrice: {
  //         margin: [0, 5, 10, 5],
  //         fontSize: 15,
  //         alignment: 'right'
  //       },
  //       amountTH: {
  //         margin: [15, 4, 0, 0],
  //         fontSize: 15,
  //         alignment: 'left'
  //       },
  //       amountFooter: {
  //         margin: [0, 4, 0, 0],
  //         fontSize: 15,
  //         alignment: 'right'
  //       },
  //       totalFooter: {
  //         margin: [0, 4, 0, 0],
  //         fontSize: 15,
  //         alignment: 'right',
  //         bold: true
  //       },
  //       detailAmountFooter: {
  //         margin: [0, 0, 10, 0],
  //         fontSize: 15,
  //         alignment: 'right'
  //       },
  //       totalAmountFooter: {
  //         margin: [0, 0, 10, 0],
  //         fontSize: 15,
  //         alignment: 'right',
  //         bold: true
  //       },
  //       lineBreak: {
  //         margin: [0, 0, 0, 10]
  //       },
  //       blankFooter: {
  //         margin: [0, 0, 0, 0]
  //       },
  //       NameSignatureFooter: {
  //         margin: [0, 0, 0, 10],
  //         alignment: 'center'
  //       },
  //       signatureImg: {
  //         margin: [0, 90, 0, 10],
  //         alignment: 'center'
  //       },
  //       logoChulaTitle: {
  //         margin: [0, 0, 0, 20],
  //         alignment: 'center'
  //       }
  //     },
  //     defaultStyle: {
  //       columnGap: 20,
  //       font: 'THsarabunNew'
  //     },
  //     info: {
  //       title: receipt.paymentID,
  //       fileName: receipt.paymentID,
  //     },
  //   };

  //   // pdfMake.createPdf(documentDefinition).open();
  //   var pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  //   pdfDocGenerator.getBase64((base64) => {
  //     // // console.log(base64);
  //     let body = {
  //       PAYMENT_ID: this.paymentID,
  //       base64str: base64,
  //     };
  //     this.paymentService.saveBase64ReceiveBill(body).subscribe((res) => {
  //       // // console.log(res);
  //     });
  //   });
  // }

}
